module.exports = __webpack_public_path__ + "img/index_yxjc.585cf9a7.svg";